exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control-label[data-v-5df2aa79] {\n    font-weight: bold;\n}\n", ""]);

// exports
